import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-2 ant-col-xl-2" }
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_9 = ["value"]
const _hoisted_10 = { class: "ant-col ant-col-xs-11 ant-col-xl-11" }
const _hoisted_11 = ["value"]
const _hoisted_12 = {
  key: 0,
  class: "acoes-item"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = {
  key: 2,
  class: "ss-table-apresentacao-mobile"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("b", null, "Emissão:", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("b", null, "Correção:", -1)
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { key: 3 }
const _hoisted_20 = { class: "ant-row" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-24" }
const _hoisted_22 = { class: "ant-row" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-20 ant-col-20" }, null, -1)
const _hoisted_24 = { class: "ant-col ant-col-xs-4 ant-col-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_alert = _resolveComponent("a-alert")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_card = _resolveComponent("card")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    title: "Cartas de Correção(CC-e)",
    footer: null,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    width: "60%",
    centered: "",
    "wrap-class-name": "ss-modal-vendas"
  }, {
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, { layout: "vertical" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_alert, {
                message: "",
                description: "A Carta de Correção é disciplinada pelo § 1º-A do art. 7º do Convênio S/N, de 15 de dezembro de 1970 e pode ser utilizada para regularização de erro ocorrido na emissão de documento fiscal, desde que o erro não esteja relacionado com: I - as variáveis que determinam o valor do imposto tais como: base de cálculo, alíquota, diferença de preço, quantidade, valor da operação ou da prestação; II - a correção de dados cadastrais que implique mudança do remetente ou do destinatário; III - a data de emissão ou de saída.",
                type: "info",
                "show-icon": ""
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_a_form_item, {
                label: "Número",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    value: _ctx.state.notaFiscal.numeroNotaFiscal,
                    disabled: ""
                  }, null, 8, _hoisted_5)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_a_form_item, {
                label: "Emissão",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    value: _ctx.UtilitarioData.aplicaFormatoDataHoraMinuto(_ctx.state.notaFiscal.dataEmissao),
                    disabled: ""
                  }, null, 8, _hoisted_7)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_a_form_item, {
                label: "Destinatário",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    value: _ctx.state.notaFiscal.destinatario.nomeRazaoSocial,
                    disabled: ""
                  }, null, 8, _hoisted_9)
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_a_form_item, {
                label: "Chave de Acesso",
                class: "ss-margin-campos"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("input", {
                    type: "text",
                    class: "ant-input",
                    value: _ctx.state.notaFiscal.chaveAcesso,
                    disabled: ""
                  }, null, 8, _hoisted_11)
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_card, { titulo: "HISTÓRICO DE CARTAS" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_table, {
                columns: _ctx.gradeBase.colunas.filter(item => item.visible),
                "data-source": _ctx.state.cartas,
                rowKey: "index",
                pagination: false,
                loading: _ctx.telaBase.carregando,
                scroll: _ctx.gradeBase.layoutMobile?null: { y: _ctx.window.innerHeight - 500 },
                "row-selection": { selectedRowKeys: _ctx.gradeBase.codigosSelecionados },
                size: "small"
              }, {
                bodyCell: _withCtx(({ column, record, text, index }) => [
                  (column.key === 'acoes')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("a", {
                          class: "visualizar",
                          onClick: ($event: any) => (_ctx.imprimirCCe(index))
                        }, [
                          _createVNode(_component_icone, { nome: "imprimir" })
                        ], 8, _hoisted_13)
                      ]))
                    : (column.key === 'DataEmissao')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.UtilitarioData.aplicaFormatoDataHoraMinutoSegundo(text)), 1))
                      : (column.key === 'Carta')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("span", null, [
                              _hoisted_16,
                              _createTextVNode(_toDisplayString(record.dataEmissao), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _hoisted_17,
                              _createTextVNode(_toDisplayString(record.correcao), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _createElementVNode("a", {
                                class: "visualizar",
                                onClick: ($event: any) => (_ctx.imprimirCCe(index))
                              }, [
                                _createVNode(_component_icone, { nome: "imprimir" })
                              ], 8, _hoisted_18)
                            ])
                          ]))
                        : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(text), 1))
                ]),
                emptyText: _withCtx(() => [
                  _createVNode(_component_mensagem_sem_dados, {
                    resultadoPesquisa: !_ctx.telaBase.carregando,
                    mensagem: "Nenhuma correção feita para está nota fiscal."
                  }, null, 8, ["resultadoPesquisa"])
                ]),
                _: 1
              }, 8, ["columns", "data-source", "loading", "scroll", "row-selection"])
            ]),
            _: 1
          }),
          _createVNode(_component_card, { titulo: "NOVA CARTA" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _createVNode(_component_a_form_item, {
                    label: "Carta",
                    class: "ss-margin-campos"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("textarea", {
                        class: "ant-input",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.carta.correcao) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.state.carta.correcao]
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("button", {
                    class: "ant-btn ant-btn-primary",
                    style: {"width":"100%"},
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emitirCCe && _ctx.emitirCCe(...args)))
                  }, "Emitir CC-e")
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_requisicao_modal, {
            visivel: _ctx.modalBase.exibirRequisicaoModal,
            "onUpdate:visivel": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
            retornoRequisicao: _ctx.modalBase.retornoRequisicao,
            apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
            fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso
          }, null, 8, ["visivel", "retornoRequisicao", "apresentarBarraProgresso", "fraseBarraProgresso"])
        ]),
        _: 1
      }),
      _createVNode(_component_preview_pdf, {
        arquivos: _ctx.state.arquivosPdf
      }, null, 8, ["arquivos"])
    ]),
    _: 1
  }, 8, ["visible"]))
}